/* unplugin-vue-components disabled */import script from "./ingred.vue?vue&type=script&setup=true&lang=ts"
export * from "./ingred.vue?vue&type=script&setup=true&lang=ts"

import "./ingred.vue?vue&type=style&index=0&id=085dd978&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-085dd978"]])

export default __exports__